import React from 'react';

const FormActions = ({
  config,
  componentShowingState,
  submitInProgress,
  childSubFormOpen,
  disabledIf,
  submit,
  cancel,
  linkToSettings
}) => {
  const STATE_NEW = 'new';
  const STATE_EDIT = 'edit';
  const STATE_COPY_FROM_SYSTEM = 'copy_from_system';

  if (!config.submit.enabled && !config.cancel.enabled) {
    return null;
  }

  return (
    <tr>
      <td colSpan="2">
        {config.cancel.enabled && <button className="btn" disabled={childSubFormOpen} onClick={cancel}> {t('quote_builder.cancel')} </button>}

        &nbsp;
        &nbsp;

        {config.submit.enabled && <button className="btn simple-btn" type='button' disabled={disabledIf()} onClick={submit} >
          {submitInProgress && t('three_d.please_wait')}
          {!submitInProgress && componentShowingState == STATE_NEW && t('quote_builder.save') }
          {!submitInProgress && componentShowingState == STATE_COPY_FROM_SYSTEM && t('quote_builder.save') }
          {!submitInProgress && componentShowingState == STATE_EDIT && t('quote_builder.update') }
        </button> }

        {linkToSettings && <div className="float-right"> <small> <a href={`/quote-builder/settings/${config.key}`} target="_blank"> <i className="fa fa-cog" aria-hidden="true"></i> {t('nav.quote_builder_settings_long')} </a>  </small> </div> }
      </td>
    </tr>
  );
};

export default FormActions;